module.exports = __webpack_public_path__ + "img/profile.a8051625.svg";